
  
  var _invalidFunction = function(){
    throw 'This function cannot be used';
  };

  // these backbone models are client side only -- they can neither pull nor oush data.
  var NoSyncMixin = {  
    fetch: _invalidFunction,
    save: _invalidFunction,
    url: _invalidFunction,
    urlRoot: _invalidFunction,
    destroy: _invalidFunction,
    sync: _invalidFunction
  };

  var NoSyncCollection = {
    fetch: _invalidFunction,
    url: _invalidFunction,
    create: _invalidFunction,
    sync: _invalidFunction
  };

  

export { NoSyncCollection, NoSyncMixin };